import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import $ from "jquery";
import { minDate } from "../../Constants/Constants";

const UpdateTKCSOrder = ({ getData, formRef, setRowId, rowID }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [company, setCompany] = useState([]);
  const navigate = useNavigate();
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState("");
  const [tkcsOrder, setTkcsOrder] = useState([]);
  const [filterCriteria, setfilterCriteria] = useState({
    company_id: selectedCompanyId ? selectedCompanyId : "",
    product_name_id: productId,
  });
  const [productQuantity, setProductQuantity] = useState([]);

  function resetFileds() {
    setTkcsOrder({
      company_id: "",
      po_date: "",
      party_name: "",
      product_name_id: "",
      po_qty: "",
      po_number: "",
      payment_term: "",
    });
    setSelectedCompanyId("");
    setProduct([]);
    setProductQuantity([{ product_name_id: "", po_qty: "" }]);
    setRowId("");
  }

  const handleNavigate = () => {
    navigate("/private-order-detials");
  };

  useEffect(() => {
    if (tkcsOrder) {
      setProductQuantity(tkcsOrder.product_quantity_details || []);
    }
  }, [tkcsOrder]);

  const getSingleTkcsOrderDetails = async () => {
    const BASE_URL = `${SERVER_URL}/api/private-order/single-private-order/${user_id}/${rowID}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTkcsOrder(result.data);
    } else {
      setTkcsOrder(null);
    }
  };

  useEffect(() => {
    if (rowID) {
      getSingleTkcsOrderDetails();
    }
  }, [rowID]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTkcsOrder(() => {
      return {
        ...tkcsOrder,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    if (tkcsOrder) {
      setSelectedCompanyId(tkcsOrder.company_id);
    }
  }, [tkcsOrder]);

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  function handleCompanyChange(companyId) {
    if (companyId) {
      setSelectedCompanyId(parseInt(companyId));
      const updatedProductQuantity = productQuantity.map((item) => {
        return { product_name_id: "", po_qty: item.po_qty };
      });
      setProductQuantity(updatedProductQuantity);
    }
    getProductDetails();
  }

  const getProductDetails = async (e) => {
    const BASE_URL = `${SERVER_URL}/api/product/drop-products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
      }),
    });
    const result = await res.json();
    setProduct(result.data);
  };

  useEffect(() => {
    if (selectedCompanyId) {
      getProductDetails();
    }
  }, [selectedCompanyId]);

  const handleUpdateDataSubmit = async (e) => {
    e.preventDefault();
    const isAnyProductIdEmpty = productQuantity.some(
      (item) => item.product_name_id === ""
    );

    if (isAnyProductIdEmpty) {
      toast.error("Please select a product for all entries.");
      return;
    }
    const { id, po_date, party_name, po_number, payment_term } = tkcsOrder;

    let BASE_URL = SERVER_URL + `/api/private-order/private-order/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        company_id: selectedCompanyId,
        po_date,
        party_name,
        po_number,
        payment_term,
        product_quantity_details: productQuantity,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const handleAddFields = () => {
    setProductQuantity([
      ...productQuantity,
      { product_name_id: "", po_qty: "" },
    ]);
  };
  const handleClose = (index) => {
    const values = [...productQuantity];
    values.splice(index, 1);
    setProductQuantity(values);
  };

  const handleChangeInput = (index, event) => {
    const values = [...productQuantity];
    if (event.target.name === "product_name_id") {
      values[index].product_name_id = event.target.value;
    } else {
      values[index].po_qty = event.target.value;
    }
    setProductQuantity(values);
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update TKCS Order
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <div className="card-title">
                      Add Private Order &nbsp;
                      <span>
                        <button
                          className="btn btn-sm btn-light btn-icon-text border"
                          onClick={handleNavigate}
                        >
                          <i
                            className="mdi mdi-arrow-left"
                            style={{ height: "4px", width: "4px" }}
                          ></i>{" "}
                          Back{" "}
                        </button>
                      </span>
                    </div> */}

                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleUpdateDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="company_id">Company Name</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="company_id"
                              id="company_id"
                              onChange={(e) =>
                                handleCompanyChange(e.target.value)
                              }
                              required
                              value={selectedCompanyId}
                            >
                              <option value="">Select Company Name</option>
                              {company && company.length > 0 && company?.map((item, id) => {
                                return (
                                  <option
                                    value={item.id}
                                    key={id}
                                  >{`${item.company_name}, ${item.location}`}</option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="party">Party Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="party_name"
                              id="party"
                              value={tkcsOrder.party_name}
                              placeholder="Party Name"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Pole_number">Po.No</label>
                            <input
                              type="text"
                              className="form-control"
                              name="po_number"
                              id="Pole_number"
                              placeholder="Po.No"
                              value={tkcsOrder.po_number}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="pole_date">Po Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="po_date"
                              id="pole_date"
                              max={new Date().toISOString().split("T")[0]}
                              placeholder="Pole Date"
                              value={tkcsOrder.po_date}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              min={minDate}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="terms">Payment Terms</label>
                            <input
                              type="text"
                              className="form-control"
                              name="payment_term"
                              id="terms"
                              placeholder="Payment Terms"
                              value={tkcsOrder.payment_term}
                              onChange={handleChange}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Location">Location</label>
                            <input
                              type="text"
                              className="form-control"
                              name="location"
                              id="Location"
                              placeholder="Location"
                              value={rowAddData.location}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="rate">Rate</label>
                            <input
                              type="text"
                              className="form-control"
                              name="rate"
                              id="rate"
                              placeholder="Rate"
                              value={rowAddData.rate}
                              onChange={handleChange}
                            />
                          </div>
                        </div> */}
                        {productQuantity &&
                          productQuantity?.length > 0 &&
                          productQuantity?.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label htmlFor="company_id">
                                      Product Size
                                    </label>
                                    <select
                                      className="form-control form-control-lg"
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                      name="product_name_id"
                                      value={item.product_name_id}
                                      // disabled={!selectedCompanyId}
                                      id="product"
                                      required
                                    >
                                      <option value="">
                                        Select Product 
                                      </option>
                                      {product && product.length > 0 && product?.map((item, id) => {
                                        return (
                                          <option
                                            value={item.id}
                                            key={id}
                                          >{`${item.size}`}</option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label htmlFor="quantity">
                                      Po Quantity
                                    </label>
                                    <div className="input-group">
                                      <input
                                        type="number"
                                        className="form-control"
                                        name="po_qty"
                                        id="quantity"
                                        placeholder="Po Quantity"
                                        onChange={(event) =>
                                          handleChangeInput(index, event)
                                        }
                                        value={item.po_qty}
                                        required
                                        autoComplete="off"
                                      />
                                      <span className="input-group-append ml-2">
                                        <div className="col-md-2">
                                          {index > 0 ? (
                                            <button
                                              type="button"
                                              title="Remove"
                                              className="btn btn-outline-danger btn-rounded btn-icon"
                                              onClick={() => handleClose(index)}
                                            >
                                              <span className="mdi mdi-close-thick"></span>
                                            </button>
                                          ) : (
                                            <button
                                              type="button"
                                              disabled
                                              className="btn btn-outline-danger btn-rounded btn-icon"
                                            >
                                              <i className="mdi mdi-close" />
                                            </button>
                                          )}
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })}
                        <span className="input-group-append ml-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleAddFields}
                          >
                            Add More
                          </button>
                        </span>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleUpdateDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateTKCSOrder;
